const FluffyCreatureStyles = () => (
  <style>{`
    .fluffy-creature {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
    }

    .creature-body-fluffy {
      position: relative;
      width: 50px;
      height: 50px;
      background: radial-gradient(circle at 30% 30%, var(--accent-color), var(--primary-color), var(--secondary-color));
      border-radius: 45% 55% 60% 40%;
      border: 3px solid var(--secondary-color);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: breathe 2s ease-in-out infinite;
    }

    .creature-body-fluffy::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: repeating-conic-gradient(
        from 0deg,
        var(--primary-color) 0deg 30deg,
        var(--secondary-color) 30deg 60deg,
        var(--accent-color) 60deg 90deg
      );
      border-radius: 45% 55% 60% 40%;
      z-index: -1;
      opacity: 0.3;
      filter: blur(1px);
    }

    .creature-body-fluffy::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: repeating-radial-gradient(
        circle at 25% 25%,
        transparent 2px,
        var(--accent-color) 3px,
        transparent 4px,
        var(--primary-color) 6px
      );
      border-radius: 45% 55% 60% 40%;
      opacity: 0.4;
      mix-blend-mode: overlay;
    }

    .creature-eyes-large {
      display: flex;
      gap: 8px;
      z-index: 2;
      position: relative;
    }

    .eye-large {
      width: 19px;
      height: 19px;
      background: radial-gradient(circle at 30% 30%, #ffffff, #f0f0f0);
      border-radius: 50%;
      border: 2px solid #333;
      position: relative;
      animation: blink 4s infinite;
    }

    .eye-large::after {
      content: '';
      position: absolute;
      width: 11px;
      height: 11px;
      background: radial-gradient(circle at 30% 30%, #1a1a1a, #000);
      border-radius: 50%;
      top: 1px;
      left: 2px;
    }

    .eye-large::before {
      content: '';
      position: absolute;
      width: 4px;
      height: 4px;
      background: rgba(255,255,255,0.9);
      border-radius: 50%;
      top: 2px;
      left: 3px;
      z-index: 1;
    }

    @keyframes breathe {
      0%, 100% { transform: scale(1) rotate(0deg); }
      25% { transform: scale(1.02) rotate(1deg); }
      50% { transform: scale(1.04) rotate(0deg); }
      75% { transform: scale(1.02) rotate(-1deg); }
    }

    @keyframes blink {
      0%, 90%, 100% { transform: scaleY(1); }
      95% { transform: scaleY(0.1); }
    }

    .creature-ears {
      position: absolute;
      top: -17px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 8px;
      z-index: 1;
    }

    .creature-ear {
      width: 12px;
      height: 30px;
      background: linear-gradient(to bottom, var(--primary-color), var(--secondary-color));
      border: 2px solid var(--secondary-color);
      border-radius: 60% 40% 20% 80%;
      position: relative;
      animation: earWiggle 3s ease-in-out infinite;
      transform-origin: bottom center;
    }

    .creature-ear.left {
      transform: rotate(-15deg);
      animation-delay: 0.2s;
      transform-origin: bottom center;
    }

    .creature-ear.right {
      transform: rotate(15deg);
      animation-delay: 0.4s;
      animation-name: earWiggleRight;
      transform-origin: bottom center;
    }

    .creature-ear::before {
      content: '';
      position: absolute;
      width: 6px;
      height: 18px;
      background: var(--accent-color);
      border-radius: 50% 30% 20% 70%;
      top: 3px;
      left: 2px;
    }

    .creature-hands {
      position: absolute;
      top: 60%;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 35px;
      z-index: -1;
    }

    .creature-hand {
      width: 8px;
      height: 8px;
      background: var(--primary-color);
      border: 1px solid var(--secondary-color);
      border-radius: 50%;
      animation: handWave 2.5s ease-in-out infinite;
    }

    .creature-hand.left {
      animation-delay: 0.1s;
    }

    .creature-hand.right {
      animation-delay: 0.3s;
    }

    .creature-feet {
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 20px;
      z-index: -1;
    }

    .creature-foot {
      width: 10px;
      height: 6px;
      background: var(--secondary-color);
      border: 1px solid var(--primary-color);
      border-radius: 60% 40% 50% 50%;
      animation: footTap 4s ease-in-out infinite;
    }

    .creature-foot.left {
      animation-delay: 0.5s;
    }

    .creature-foot.right {
      animation-delay: 1s;
    }

    @keyframes earWiggle {
      0%, 100% { transform: rotate(-15deg) scale(1); }
      50% { transform: rotate(-25deg) scale(1.02); }
    }

    @keyframes earWiggleRight {
      0%, 100% { transform: rotate(15deg) scale(1); }
      50% { transform: rotate(25deg) scale(1.02); }
    }

    @keyframes handWave {
      0%, 100% { transform: translateY(0px) scale(1); }
      25% { transform: translateY(-2px) scale(1.1); }
      75% { transform: translateY(1px) scale(0.9); }
    }

    @keyframes footTap {
      0%, 90%, 100% { transform: translateY(0px); }
      95% { transform: translateY(-1px); }
    }
  `}</style>
);

export default FluffyCreatureStyles;
